"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _category = require("../category");

require("./Navigation.css");

var NavigationBasicTabs = function NavigationBasicTabs(_ref) {
  var center = _ref.center;
  return /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var schedules = _ref2.schedules,
        disableSchedules = _ref2.disableSchedules;
    var panes = schedules.map(function (schedule) {
      var name = schedule.name,
          _id = schedule._id;
      return {
        menuItem: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, {
          key: name
        }, !disableSchedules && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h3"
        }, name)),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Tab.Pane, {
            key: name
          }, /*#__PURE__*/_react["default"].createElement(_category.CategoryContainer, {
            scheduleId: _id
          }));
        }
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Tab, {
      panes: panes,
      className: getClassNames({
        center: center,
        disableSchedules: disableSchedules
      })
    });
  });
};

function getClassNames(_ref3) {
  var center = _ref3.center,
      disableSchedules = _ref3.disableSchedules;
  var classNames = ['fcfm-tabs-container'];
  if (center) classNames = [].concat((0, _toConsumableArray2["default"])(classNames), ['center']);
  if (disableSchedules) classNames = [].concat((0, _toConsumableArray2["default"])(classNames), ['disable-menu-schedules']);
  return classNames.join(' ');
}

var _default = NavigationBasicTabs;
exports["default"] = _default;